
import moment from 'moment/moment';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import * as planningNumeriqueConf from '@/components/creationOpportunite/configuration/planningNumeriqueConf';

export default function decorateurRectanglePanneauxNumeriquesSemaine(rectangle, panNum,
  dateStart, granularite) {
  rectangle.panNum = panNum;

  const dateDebut = moment(dateStart);
  rectangle.key = `r${panNum}${dateDebut.format('YYYYMMDD')}`;
  if (granularite === planningNumeriqueConf.GRANULARITY_DAY) {
    rectangle.periode = dateDebut.format('DD/MM/YYYY');
  }

  if (granularite === planningNumeriqueConf.GRANULARITY_WEEK) {
    const semaine = dateDebut.isoWeek();
    const annee = dateDebut.isoWeekYear();
    rectangle.periode = `S${semaine} / ${annee}`;
  }

  if (rectangle.selectionne) {
    rectangle.fill = niveauDispo.COULEUR_DISPO_INCONNU;
    rectangle.stroke = niveauDispo.COULEUR_DISPO_INCONNU;
    rectangle.texte = '';
    switch (Math.trunc(rectangle.selectionne / 100) * 100) {
      case planningNumeriqueConf.TYPE_VENTE_FULL:
        rectangle.texte = 'F';
        break;
      case planningNumeriqueConf.TYPE_VENTE_ACCESS:
        rectangle.texte = 'A';
        break;
      default:
        break;
    }
    rectangle.textColor = niveauDispo.COULEUR_BLANCHE;
    rectangle.widthOccupation = false;
  }
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectanglePanneauxNumeriquesVente.js